import { IconAngleRight } from '@iwoca/icons';
import IwLink from '@iwRouter/IwLink';

import shopIcon from './shopIcon.svg';

export const SellerDirectoryBanner = () => {
    return (
        <div className="my-xs box-border flex w-full items-start justify-start gap-l rounded-s border border-solid border-secondary-90 px-l py-m">
            <img src={shopIcon} alt="shop icon" className="w-[50px]" />
            <div className="flex flex-col">
                <IwLink
                    to="/iwocapay/directory/"
                    className="inline-flex items-center gap-xs text-left text-m font-bold !text-primary-40"
                >
                    Find an iwocaPay supplier{' '}
                    <IconAngleRight className="fill-primary-40" />
                </IwLink>
                <span className="text-s font-reg">
                    You can use your spending limit at any supplier that offers
                    iwocaPay Pay Later. Just choose iwocaPay at the checkout.
                </span>
            </div>
        </div>
    );
};
